module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Media/Backward-6f482218794b68eb60aa3fa51bebd253.svg";